import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/solution/demograpics.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/QuantisCrousel/index.tsx");
